import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import {
  get_Transaction_Category,
  get_Single_Transaction_Category,

} from "../../../store/actions/CommanAction";
import Loader from "../Loader/Loader";
import Select from "react-select";

const TransactionCategory = () => {
  const dispatch = useDispatch();
  const TransactionData = useSelector(
    (state) => state.feedBackReducer.TransactionCategory
  );
  const TransactionSingleData = useSelector(
    (state) => state.feedBackReducer.TransactionSingleCategory
  );


  const customerID = Number(sessionStorage.getItem("ID"));

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [DregeeID, setDregeeID] = useState("");
  const [loading, setLoading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    TransactionType: "",
    Category: "",
    CreatedByUser: "1",
    IsActive: "1",
  });

  const Reset = () => {
    setaddFormData({ ...addFormData, Category: "", TransactionType: "" });
  };

  useEffect(() => {
    if (TransactionSingleData) {
      setEditValue(TransactionSingleData);
    }
  }, [TransactionSingleData]);


  useEffect(() => {
    if (IsActive) {
      dispatch(get_Transaction_Category("1", setLoading));
    } else {
      dispatch(get_Transaction_Category("0", setLoading));
    }
  }, [IsActive, IsActive]);

  useEffect(() => {
    if (EditValue && EditValue.length > 0) {
      setaddFormData({
        ...addFormData,

        Category: EditValue[0]?.Category,
        TransactionType: EditValue[0]?.TransactionType,

      });
    }
  }, [EditValue]);

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();


    let error = false;
    let errorMsg = "";
   

    const trimmedTransactionType = addFormData.TransactionType.trim();
    const trimmedCategory = addFormData.Category?.trim() || "";

    if (!trimmedTransactionType) {
      error = true;
      errorMsg = "Please fill Transaction Type.";
    }

    if (!trimmedCategory) {
      error = true;
      errorMsg = "Please fill Transaction Category.";
    }

    const isDuplicate = TransactionData.some(
      (item) =>
        item.Category.trim().toLowerCase() === trimmedTransactionType.toLowerCase()
    );

    if (isDuplicate) {
      error = true;
      errorMsg = "Give Proper Transaction name or Catagory and Category do not duplicate.";
    }


    if (!error) {
      const insertdata = {
        TransactionType: addFormData.TransactionType,
        Category: addFormData.Category,
        IsActive: addFormData.IsActive,
        CreatedByUser: customerID,
      };
      await AddUpdate(
        "TransactionCategory/Insert_TransactionCategory",
        insertdata
      );
      setPostModal(false);
      dispatch(get_Transaction_Category(IsActive, setLoading));
      swal("Good job!", "Successfully Added", "success");
      Reset();
      setaddFormData({ Category: "", TransactionType: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };



  const UpdateSlider = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    const trimmedTransactionType = addFormData.TransactionType.trim();
    const trimmedCategory = addFormData.Category?.trim() || "";

    if (!trimmedTransactionType) {
      error = true;
      errorMsg = "Please fill Transaction Type.";
    }

    if (!trimmedCategory) {
      error = true;
      errorMsg = "Please fill Transaction Category.";
    }
    if (!error) {
      const updatedata = {
        TransactionType: addFormData.TransactionType,
        Category: addFormData.Category,
        ModifiedByUser: customerID,
        ID: DregeeID
      };
      await AddUpdate(
        "TransactionCategory/Update_TransactionCategory",
        updatedata
      );
      setEditModal(false);
      dispatch(get_Transaction_Category(IsActive, setLoading));
      swal("Good job!", "Successfully update", "success");
      Reset();
      setaddFormData({ Category: "", TransactionType: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const handleAddFormChange = (e) => {
    setaddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditClick = (row) => {
    dispatch(get_Single_Transaction_Category(row?.ID));
    setDregeeID(row?.ID);
    setEditModal(true);
  };

  const columns = [
    {
      name: "Transaction Type",
      selector: (row) => row.TransactionType,
      sortable: true,
    },
    {
      name: "Transaction Category",
      selector: (row) => row.Category,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(row.ID, true, "0");
                }}
              >
                Inactive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      name: "TransactionType",
      selector: (row) => row.TransactionType,
      sortable: true,
    },
    {
      name: "Transaction Category",
      selector: (row) => row.Category,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.ID, false, "1");
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const handleToggleStatusClick = async (
    DregeeID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      ID: DregeeID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };
    await AddUpdate("TransactionCategory/Delete_TransactionCategory", postData);
    dispatch(get_Transaction_Category(currentStatus ? "1" : "0", setLoading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };


  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: '#fdba74',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#fdba74',
      },
    }),
  };





  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="main_card mb-2">
          <div className="mt-2 d-flex justify-content-between align-items-center flex-wrap">
            <div className="card-action coin-tabs">
              <Nav as="ul" className="nav nav-tabs" role="tablist">
                <Nav.Item as="li" className="nav-item">
                  <Nav.Link
                    className="nav-link"
                    eventKey="All"
                    onClick={(currentStatus) => {
                      setIsActive(true);
                    }}
                  >
                    Active
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li" className="nav-item">
                  <Nav.Link
                    className="nav-link"
                    eventKey="Inactive"
                    onClick={(currentStatus) => {
                      setIsActive(false);
                    }}
                  >
                    Inactive
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <Link
              to={"#"}
              className="btn btn-primary font-w600 "
              onClick={() => {
                setPostModal(true);
                Reset();
              }}
            >
              + New Transaction
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-3 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">
                              Add Transaction
                            </h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <label htmlFor="transaction">Transaction</label>
                                <span className="text-danger star-error">
                                  *
                                </span>
                                <Select
                                  name="TransactionType"
                                  value={
                                    [
                                      { value: "Payment", label: "Payment" },
                                      { value: "Receive", label: "Receive" },
                                    ].find(
                                      (obj) =>
                                        obj.value ===
                                        addFormData?.TransactionType
                                    ) || null
                                  }
                                  options={[
                                    { value: "Payment", label: "Payment" },
                                    { value: "Receive", label: "Receive" },
                                  ]}
                                  onChange={(selectedOption) =>
                                    handleAddFormChange({
                                      target: {
                                        name: "TransactionType",
                                        value: selectedOption?.value || "",
                                      },
                                    })
                                  }
                                  placeholder="Select Transaction..."
                                  isClearable={true}
                                  classNamePrefix="form-select"
                                  required
                                  styles={customStyles}
                                />
                              </div>
                              
                              <div className="form-group mt-2">
                                <label className="form-label">
                                  Transaction Category
                                </label>
                                <input
                                  type="text"
                                  // className="form-control"
                                  name="Category"
                                  value={addFormData?.Category || ""}
                                  onChange={handleAddFormChange
                                  }
                                  placeholder="Enter Category..."
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit Transaction
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>

                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-content">
                                  <label htmlFor="transaction">
                                    Transaction
                                  </label>
                                  <span className="text-danger star-error">
                                    *
                                  </span>
                                  <Select
                                    name="TransactionType"
                                    value={
                                      [
                                        { value: "Payment", label: "Payment" },
                                        { value: "Receive", label: "Receive" },
                                      ].find(
                                        (obj) =>
                                          obj.value ===
                                          addFormData?.TransactionType
                                      ) || null
                                    }
                                    options={[
                                      { value: "Payment", label: "Payment" },
                                      { value: "Receive", label: "Receive" },
                                    ]}
                                    onChange={(selectedOption) =>
                                      handleAddFormChange({
                                        target: {
                                          name: "TransactionType",
                                          value: selectedOption?.value || "",
                                        },
                                      })
                                    }
                                    placeholder="Select Transaction..."
                                    isClearable={true}
                                    classNamePrefix="form-select"
                                    required
                                    styles={customStyles}
                                  />
                                </div>
                                
                                <div className="form-group mt-2">
                                  <label className="form-label">
                                    Transaction Category
                                  </label>
                                  <input
                                    type="text"
                                    // className="form-control"
                                    name="Category"
                                    value={addFormData?.Category || ""}
                                    onChange={handleAddFormChange
                                    }
                                    placeholder="Enter Category..."
                                    required
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateSlider}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={TransactionData}
                          columns={columns}
                          selectableRowsHighlight
                          pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      )}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={TransactionData}
                            columns={columns1}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                          />
                        )}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
    </>
  );
};
export default TransactionCategory;
